import { Button, Modal, Text, Textarea } from "@imagedesignai/neo";

export function ShareRecoveryModal(props: {
  payload: string;
  onClose(): void;
  onCopy(): Promise<void>;
}) {
  return (
    <Modal title="Copy link" onClose={props.onClose}>
      <div className="share-recovery">
        <Text kind="body" tone="secondary">
          Your share is active. Copy this text if the browser blocked the first attempt.
        </Text>
        <Textarea label="Share URL" readOnly value={props.payload} />
        <Button intent="positive" size="sm" icon="link-2" onClick={() => void props.onCopy()}>
          Copy link
        </Button>
      </div>
    </Modal>
  );
}
